$(function() {

	if (footnotesDetect()) footnotesInit();


	$('.wysiwyg-container').on({
		'mouseenter' : function(event) {
			$('.post-editor-element-footnote').eq($('.footnote').index($(this))).addClass('active');
		},
		'mouseleave' : function(event) {
			$('.post-editor-element-footnote').eq($('.footnote').index($(this))).removeClass('active');
		}
	}, '.footnote');


	$('.post-editor-content').on({
		'mouseenter' : function(event) {
			$('.footnote').eq($('.post-editor-element-footnote').index($(this))).addClass('active');
		},
		'mouseleave' : function(event) {
			$('.footnote').eq($('.post-editor-element-footnote').index($(this))).removeClass('active');
		}
	}, '.post-editor-element-footnote');

});


// Проверка существования на странице сносок
function footnotesDetect() {
	return $('.footnote').length > 0 ? true : false;
}


// Инициализация сносок
function footnotesInit() {
	footnotesSetContent();
	footnotesSetPosition();
}


// Инициализация контента сносок
function footnotesSetContent() {
	var postEditorContent = $('.post-editor-content');

	postEditorContent.find('.footnote').each(function(index) {
		$('<div class="post-editor-element-footnote"></div>').appendTo(postEditorContent).html($(this).data('caption'));

		$(this).parents('[class*="post-editor__section_"]').addClass('with-footnote');
	});
}


// Позиционирование сносок
function footnotesSetPosition() {
	var postEditorContent = $('.post-editor-content');

	postEditorContent.find('.post-editor-element-footnote').each(function(index) {
		$(this).css('top', postEditorContent.find('.footnote').eq(index).parents('[class*="post-editor-element-"]').offset().top - postEditorContent.offset().top);
	});
}